/**
 * Readable names for model ids we know. Anything else renders verbatim:
 * a new frontier model should show up on day one under its raw id rather
 * than waiting for a release that teaches the dashboard its marketing
 * name. A catalog of ids belongs here (not in i18n) because model names
 * are proper nouns and identical in every locale.
 */
const MODEL_LABELS: Readonly<Record<string, string>> = {
  'deepseek-flash': 'DeepSeek V4.1 Flash',
  'deepseek-v4-pro': 'DeepSeek V4 Pro',
  'claude-opus-5-5': 'Claude Opus 5.5',
  'claude-sonnet-5-5': 'Claude Sonnet 5.5',
  'claude-haiku-5-5': 'Claude Haiku 5.5',
  'claude-fable-5-1': 'Claude Fable 5.1',
}

/** The id the per-model report uses when no model could be attributed. */
export const UNKNOWN_MODEL = 'unknown'

/**
 * `unknownLabel` is the caller's localized name for {@link UNKNOWN_MODEL};
 * without it the sentinel renders as-is.
 */
export function modelLabel(model: string, unknownLabel?: string): string {
  if (model === UNKNOWN_MODEL && unknownLabel) return unknownLabel
  return MODEL_LABELS[model] ?? model
}
